import {
  makeStyles,
  tokens
} from "@fluentui/react-components";

export const loginStyles = makeStyles({
  container: {
    height: "100vh",
    display: "grid",
    alignContent: "center"
  },
  root: {
    border: tokens.strokeWidthThick + ' solid ' + tokens.colorNeutralBackground3,
    borderRadius: tokens.borderRadiusMedium,
    overflow: "visible",
    padding: "40px",
    boxSizing: "border-box",
    boxShadow: tokens.shadow16,
    margin: "50px",
    display: "flex",
    flexDirection: "column",
    maxWidth: "450px",
    marginLeft: "auto",
    marginRight: "auto"
  },
  image: {
    width: "100%",
    height: "80px"
  },
  inputList: {
    display: "contents",
    alignItems: "center",
    justifyItems: "center",
    justifyContent: "center"
  },
  input: {
    margin: "10px 0 0 0"
  },
  buttons: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    alignItems: 'center',
    textAlign: 'end'
  },
  forgotPassword: {
    textDecoration: 'none',
    color: tokens.colorBrandBackgroundHover,
    fontWeight: 600
  },
  button: {
    margin: "10px 0 10px 0"
  },
  termsText: {
    alignItems: "center",
    justifyItems: "center",
    justifyContent: "center",
    textAlign: "center",
    margin: "10px 0 0 0",
    fontSize: "10px",
  },
  copyRightFont: {
    fontSize: "14px",
    fontWeight: "bold",
    textAlign: "center"
  },
  copyRightSubFont: {
    fontSize: "12px",
    textAlign: "center"
  },
  newToBIMComply: {
    margin: '0.5rem 0px 2.5rem 0px',
    fontWeight: 600
  },
  createAccount: {
    textDecoration: 'none',
    color: tokens.colorBrandBackgroundHover,
    fontWeight: 600,
    paddingLeft: '0.5rem',
    marginBottom: '1rem'
  }
});
